import { useEffect, useState } from 'react'
import { EventsCollection } from './EventsCollection.js'
import { useFetch } from '../hooks/index.js'
import { useLocation } from 'react-use';
import {
	always,
	pipe,
} from 'ramda'
import {
	isUpcoming,
	isFeatured
} from '../utils.js'

import {
	maybeFilterBy
} from '../../../utils/index.js'

const maybeFilterEvents = ({ upcomingOnlyEnabled, showOnlyFeatured, events }) => {
	return pipe(
		maybeFilterBy(isUpcoming, always(upcomingOnlyEnabled)),
		maybeFilterBy(isFeatured, always(showOnlyFeatured))
	)(events)
}

export function EventsCollectionWithFetch(props = {}) {
	const {
		searchControlEnabled = false,
		searchControlPlaceholder = 'Enter keywords',
		searchControlLabel = 'Search',
		filterControlsEnabled = false,
		selectedSortOptions = [],
		taxonomyFilters = [],
		columns = 3,
		rows = 3,
		sortByEnabled,
		loadMoreEnabled,
		viewToggleEnabled,
		upcomingOnlyEnabled,
		showOnlyFeatured,
		view: defaultView = 'grid'
	} = props;



	const [events, fetchEvents] = useFetch("/wp-json/wp/v2/events?per_page=20&order_by='date&order=desc&_embed=true", {}, [])
	const [taxonomies, fetchTaxonomies] = useFetch("/wp-json/wp/v2/taxonomies?per_page=100&context=embed&_embed=true", {}, [])

	return (
		<EventsCollection
			events={maybeFilterEvents({ showOnlyFeatured, upcomingOnlyEnabled, events }).sort((a, b) => {
				return Date.parse(a.meta.eventStartDate) - Date.parse(b.meta.eventStartDate)
			})}
			searchControlEnabled={searchControlEnabled}
			searchControlPlaceholder={searchControlPlaceholder}
			searchControlLabel={searchControlLabel}
			filterControlsEnabled={filterControlsEnabled}
			taxonomyFilters={taxonomyFilters}
			taxonomies={taxonomies}
			postTypeFilterControlEnabled={false}
			columns={columns}
			rows={rows}
			selectedSortOptions={selectedSortOptions}
			sortByEnabled={sortByEnabled}
			loadMoreEnabled={loadMoreEnabled}
			upcomingOnlyEnabled={upcomingOnlyEnabled}
			viewToggleEnabled={viewToggleEnabled}
		/>
	)
}

export default EventsCollectionWithFetch
